// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2V4-x","inputDescription":"styles_inputDescription__298ZL"};